import { format, parseISO } from 'date-fns';
import { DataCellProps } from '../../types';

const LastSyncTimeDataCell = ({ _customRowProps, lastSyncTime }: DataCellProps) => {
  if (!lastSyncTime) return <></>;

  return <div>{format(parseISO(lastSyncTime), 'MMMM do yyyy, h:mm:ss a')}</div>;
};

export default LastSyncTimeDataCell;
